import React from 'react';
import styled, { css, keyframes } from 'styled-components';

type IProps = {
  // 0..100; ignored when indeterminate.
  percent: number;
  tone?: 'active' | 'success' | 'error';
  indeterminate?: boolean;
  className?: string;
};

const TONE_COLOR = {
  active: '#2563eb',
  success: '#15803d',
  error: '#b91c1c',
};

// The publish progress bar of the Publish module: slim rounded track in the panel's
// design language (gray-200 track, tone-colored fill, soft shimmer while indeterminate).
const PublishProgressBar: React.FC<IProps> = ({ percent, tone = 'active', indeterminate = false, className }) => (
  <Track className={className}>
    <Fill
      $color={TONE_COLOR[tone]}
      $indeterminate={indeterminate}
      style={{ width: indeterminate ? '100%' : `${Math.max(0, Math.min(100, percent))}%` }}
    />
  </Track>
);

export default PublishProgressBar;

const shimmer = keyframes`
  0% { opacity: 0.35; }
  50% { opacity: 0.85; }
  100% { opacity: 0.35; }
`;

const Track = styled.div`
  height: 8px;
  border-radius: 999px;
  background-color: #e5e7eb;
  overflow: hidden;
  flex: 1 1 auto;
  min-width: 60px;
`;

const Fill = styled.div<{ $color: string; $indeterminate: boolean }>`
  height: 100%;
  border-radius: 999px;
  background-color: ${({ $color }) => $color};
  transition: width 0.25s ease;
  ${({ $indeterminate }) =>
    $indeterminate &&
    css`
      animation: ${shimmer} 1.4s ease-in-out infinite;
    `}
`;
